import { fromJS } from "immutable";
import * as actionTypes from "../constants";

export const initialState = fromJS({
  client: {
    personId: null,
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    lifeExpectancyAge: 90,
    retirementAge: 65,
    addressList: [],
    phoneList: [],
    emailList: [],
  },
  coClient: {
    personId: null,
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    lifeExpectancyAge: 85,
    retirementAge: 50,
  },
  family: [],
});

export default function reducer(state = initialState, action) {
  let family = state.get("family").toJS();

  switch (action.type) {
    case actionTypes.SET_CURRENT_CLIENT:
      return state.set("client", fromJS(action.data));
    case actionTypes.SET_CURRENT_COCLIENT:
      return state.set("coClient", fromJS(action.data));
    case actionTypes.SET_CURRENT_FAMILY:
      return state.set("family", fromJS(action.data));
    case actionTypes.SET_CURRENT_FAMILY_MEMBER:
      console.log("Updating: ", action.member);

      let added = false;

      family = family.map((f) => {
        if (f.id !== action.member.id) return f;
        added = true;
        return action.member;
      });

      if (!added) {
        family = family.concat([action.member]);
      }

      return state.set("family", fromJS(family));
    case actionTypes.REMOVE_COCLIENT:
      return state.set(
        "coClient",
        fromJS({
          personId: null,
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          lifeExpectancyAge: 85,
          retirementAge: 50,
        })
      );
    case actionTypes.ADD_FAMILY_MEMBER:
      family.push(action.data);
      return state.set("family", fromJS(family));
    case actionTypes.REMOVE_FAMILY_MEMBER:
      family = family.filter((f) => {
        return f.personId !== action.data.personId;
      });
      return state.set("family", fromJS(family));
    case actionTypes.REMOVE_ALL_FAMILY_MEMBER:
      return state.set("family", fromJS([]));
    default:
      return state;
  }
}
